// The Readiness Rate report as a CSV, oldest day first: one row per questionnaire (the five
// answers, the score, its status against that day's normal, the normal's low and high, and the
// day's Session RPE, HRV and Resting HR) and one row per missed training day.

import convertToRiR from "../converters/convert-intensity";
import { READINESS_KEYS } from "./constants";

const HEADER = [
  "Date",
  "Sore",
  "Stress",
  "Energy",
  "Mood",
  "Sleep",
  "Score",
  "Status",
  "Normal low",
  "Normal high",
  "Session RPE",
  "HRV (ms)",
  "HRV source",
  "Resting HR (bpm)",
];

const EMPTY_ANSWERS = READINESS_KEYS.map(() => "");

// A cell that has a comma, a quote or a line break is quoted, with its quotes doubled
export const escapeCsvCell = (value) => {
  if (value == null) return "";
  const text = String(value);
  return /[",\n\r]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
};

/**
 * Converts a UTC date to an ISO date.
 * @param {*} utcDate
 * @returns
 */
const toIsoDate = (utcDate) => {
  const text = String(utcDate);
  return `${text.slice(0, 4)}-${text.slice(4, 6)}-${text.slice(6, 8)}`;
};

/**
 * Builds a row for a questionnaire day.
 * @param {*} day
 * @returns
 */
const questionnaireRow = (day, isRiR) => [
  toIsoDate(day.utcDate),
  ...READINESS_KEYS.map(
    (key) => day.answers.find((answer) => answer.key === key).value
  ),
  day.total,
  day.status,
  day.normal?.lo,
  day.normal?.hi,
  convertToRiR(day.sessionRpe, !isRiR),
  day.hrv,
  day.hrvSource,
  day.restingHr,
];

/**
 * Builds a row for a missed training day.
 * @param {*} day
 * @returns
 */
const missedRow = (day) => [
  toIsoDate(day.utcDate),
  ...EMPTY_ANSWERS,
  "",
  "missed",
  "",
  "",
  "",
  "",
  "",
  "",
];

/**
 * Builds the CSV for the readiness report.
 * @param {*} report
 * @returns
 */
export const buildReadinessCsv = (report, { isRiR = false } = {}) => {
  const rows = report.days.map((day) =>
    day.kind === "missed" ? missedRow(day) : questionnaireRow(day, isRiR)
  );
  const header = HEADER.map((name) =>
    name === "Session RPE" && isRiR ? "Session RIR" : name
  );
  return [header, ...rows]
    .map((row) => row.map(escapeCsvCell).join(","))
    .join("\n");
};
